import CimsQuickLinkEntityTable from 'components/CIMSTable/common/components/CimsQuickLinkEntityTable'
import {
  useCreateFdcQuickLinkMutation,
  useEditFdcQuickLinkMutation,
  useGetFdcQuickLinksQuery,
  useRestoreFdcQuickLinkMutation,
  useSoftRemoveFdcQuickLinkMutation,
} from 'schema'
import { Permission } from '@cims-online/shared'

const FDCQuickLinks: React.FC = () => (
  <CimsQuickLinkEntityTable
    entity="Field Design Change"
    query={useGetFdcQuickLinksQuery}
    getQuickLinks={(data) => data?.fdcQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateFDCQuickLink,
      mutation: useCreateFdcQuickLinkMutation,
      getLabel: ({ createFDCQuickLink: create }) => create.fdcQuickLink,
    }}
    edit={{
      permission: Permission.EditFDCQuickLink,
      mutation: useEditFdcQuickLinkMutation,
      getLabel: ({ editFDCQuickLink: edit }) => edit.fdcQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreFDCQuickLink,
      mutation: useSoftRemoveFdcQuickLinkMutation,
      getLabel: ({ softRemoveFDCQuickLink: remove }) => remove.fdcQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreFDCQuickLink,
      mutation: useRestoreFdcQuickLinkMutation,
      getLabel: ({ restoreFDCQuickLink: restore }) => restore.fdcQuickLink,
    }}
  />
)

export default FDCQuickLinks
